import { Injectable } from '@angular/core';
import { BroadcastChannelId } from '@shared/enums/broadcast-channel-id';

@Injectable({
  providedIn: 'root',
})
export class TabCommunicationService {
  public readonly otpCodeEntered = new BroadcastChannel(BroadcastChannelId.OTP_CODE_ENTERED);
}
